export default "__VITE_ASSET__ssOwucct__"